var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import ScrollBar from "react-perfect-scrollbar";
import { connect } from "react-redux";
import { selectResourceInfo } from "../../balancingSelectors/selectBalancingResources";
import { ScrollOptions } from "../../constants/ScrollOptions";
import { IdStyles } from "../../less/IdStyles";
import { selectActiveThemedEventInfo, selectThemedEvent, selectThemedEventDifficultyLevels, selectThemedEventDifficultyLevelUnlocked, selectThemedEventTimeRemaining, } from "../../selectors/selectEventInfo";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { ReplacementLoca } from "../../utils/i18n/ReplacementLoca";
import { DialogWrapper } from "../dialog/DialogWrapper";
import { ButtonPrimary } from "../generic/common/ButtonPrimary";
import { DifficultyLevel } from "../generic/difficultyLevel/DifficultyLevel";
import { Icon } from "../generic/icon/Icon";
import { IdIcon } from "../generic/icon/IdIcon";
import { List } from "../generic/list/List";
import { TextLoca } from "../generic/text/TextLoca";
import { actionModalClose } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { TimeRemaining } from "../time/TimeRemaining";
import { actionThemedEventStartRequest } from "./actionThemedEvent";
import { ThemedEventReward } from "./ThemedEventReward";
var DialogChooseDifficultyDOM = /** @class */ (function (_super) {
    __extends(DialogChooseDifficultyDOM, _super);
    function DialogChooseDifficultyDOM() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            selectedDifficultyLevel: 0,
            startEventBtnDisabled: true,
        };
        _this.difficultyLevelLayout = function (difficultyLevel) {
            var selectedDifficultyLevel = _this.state.selectedDifficultyLevel;
            var _a = _this.props, difficultyLevels = _a.difficultyLevels, difficultyLevelUnlocked = _a.difficultyLevelUnlocked, icon = _a.icon;
            var _b = difficultyLevel, reward = _b.reward, recMinLevel = _b.recMinLevel, recMaxLevel = _b.recMaxLevel, level = _b.level;
            var rewardResource = selectResourceInfo(reward.resourceId);
            var locaReplacements = new Map([
                [ReplacementLoca.zero_0, recMinLevel.toString()],
                [ReplacementLoca.one_1, recMaxLevel.toString()],
            ]);
            var isSelected = level === selectedDifficultyLevel;
            var difficultyBackgroundClassName = IdStyles.DifficultyBackground;
            var buildingIconBackgroundClassName = IdStyles.BuildingIconBackground;
            var checkbox = React.createElement(React.Fragment, null);
            if (isSelected) {
                difficultyBackgroundClassName = IdStyles.DifficultyBackgroundSelected;
                buildingIconBackgroundClassName = IdStyles.BuildingIconBackgroundSelected;
                checkbox = React.createElement(Icon, { icon: IdIcon.QuestFinishIcn, styleId: IdStyles.IconMedium });
            }
            var isLocked = level > difficultyLevelUnlocked;
            var rewardAndSelectionDOM = (React.createElement(React.Fragment, null,
                React.createElement(ThemedEventReward, { rewardResource: rewardResource, rewardAmount: reward.amount, className: buildingIconBackgroundClassName }),
                React.createElement("div", { className: IdStyles.SelectedDifficultyTickBackground + " flex flex--guts" }, checkbox)));
            var descriptionLoca = (React.createElement(TextLoca, { className: IdStyles.TextBoldPrimary, id: IdLoca.recommendedLevel, replacements: locaReplacements }));
            var itemClassName = "difficulty-item";
            if (isLocked) {
                rewardAndSelectionDOM = (React.createElement(Icon, { icon: IdIcon.LockIcn, styleId: IdStyles.IconExtraLarge }));
                descriptionLoca = (React.createElement(TextLoca, { className: IdStyles.TextBoldPrimary, id: IdLoca.themedEvent_difficulty_unlockRequ }));
                itemClassName += " difficulty-item-locked";
            }
            return (React.createElement("div", { className: "flex flex--spaced flex--aligned " + itemClassName + " " + difficultyBackgroundClassName, onClick: function () { return _this.selectDifficulty(level, isLocked); }, key: "difficulty__" + level },
                React.createElement("div", { className: "flex flex--stacked" },
                    React.createElement(DifficultyLevel, { difficultyLevel: level, difficultyLevelMax: difficultyLevels.length }),
                    React.createElement("div", { className: "flex flex--guts" },
                        React.createElement(Icon, { icon: icon, styleId: IdStyles.IconLarge }),
                        "\u00A0",
                        descriptionLoca)),
                rewardAndSelectionDOM));
        };
        _this.selectDifficulty = function (selectedDifficultyLevel, isLocked) {
            if (isLocked) {
                return;
            }
            _this.setState({
                selectedDifficultyLevel: selectedDifficultyLevel,
                startEventBtnDisabled: false,
            });
        };
        _this.onStartEvent = function () {
            var _a = _this.props, onConfirmation = _a.onConfirmation, activeThemedEvent = _a.activeThemedEvent;
            var selectedDifficultyLevel = _this.state.selectedDifficultyLevel;
            onConfirmation(activeThemedEvent.eventId, selectedDifficultyLevel);
        };
        return _this;
    }
    DialogChooseDifficultyDOM.prototype.render = function () {
        var _a = this.props, onClose = _a.onClose, difficultyLevels = _a.difficultyLevels, remainingTime = _a.remainingTime, activeThemedEvent = _a.activeThemedEvent;
        if (!activeThemedEvent) {
            // tslint:disable-next-line:no-null-keyword
            return null;
        }
        return (React.createElement(DialogWrapper, { titleLocaId: IdLoca.themedEvent_difficulty_title, className: IdStyles.ModalBackgroundInfo, onClose: onClose },
            React.createElement("div", { className: "w100 h100 flex flex--stacked" },
                React.createElement("div", { className: "h100  difficulty-list" },
                    React.createElement(ScrollBar, { component: "div", options: ScrollOptions, className: "w100" },
                        React.createElement(List, { items: difficultyLevels, renderItem: this.difficultyLevelLayout, className: "flex flex--wrap flex--centered h100" }))),
                React.createElement("div", { className: "button-ribbon difficulty-confirm-btn flex flex--start" },
                    React.createElement(TimeRemaining, { remainingTime: remainingTime }),
                    React.createElement(ButtonPrimary, { onClick: this.onStartEvent, disabled: this.state.startEventBtnDisabled },
                        React.createElement(TextLoca, { className: IdStyles.TextButtonDefault, id: IdLoca.startEvent }))))));
    };
    return DialogChooseDifficultyDOM;
}(React.Component));
var mapState = function (state) { return ({
    activeThemedEvent: selectThemedEvent(state),
    difficultyLevelUnlocked: selectThemedEventDifficultyLevelUnlocked(state),
    difficultyLevels: selectThemedEventDifficultyLevels(state),
    icon: selectActiveThemedEventInfo(state).icon,
    remainingTime: selectThemedEventTimeRemaining(state),
}); };
var mapDispatch = function (dispatch) { return ({
    onClose: function () { return dispatch(actionModalClose(IdModal.ThemedEventDifficulty)); },
    onConfirmation: function (eventId, difficultyLevel) {
        return dispatch(actionThemedEventStartRequest(eventId, difficultyLevel));
    },
}); };
export var DialogChooseDifficulty = connect(mapState, mapDispatch)(DialogChooseDifficultyDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/themed-events/DialogChooseDifficulty.tsx
// module id = 2935
// module chunks = 3